import { render, staticRenderFns } from "./AveragePositionChart.vue?vue&type=template&id=967706d2&scoped=true&"
import script from "./AveragePositionChart.vue?vue&type=script&lang=js&"
export * from "./AveragePositionChart.vue?vue&type=script&lang=js&"
import style0 from "./AveragePositionChart.vue?vue&type=style&index=0&id=967706d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967706d2",
  null
  
)

/* custom blocks */
import block0 from "./AveragePositionChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports